import { api } from 'data/api/api'

import { moneyObjectHeader } from 'data/api/money-object-header'

import { ProfileUserInfoResp } from '../types/dtos/profile-user-info-resp'
import { GetUserItemFacetsArgs, ItemFacetsResp } from '../types/dtos/item-facets'
import { GetSellerFiltersResp } from '../types/dtos/seller-filters'

import { GetWardrobeCatalogsResp } from '../types/dtos/get-wardrobe-catalogs-resp'
import { GetWardrobeItemsArgs, GetWardrobeItemsResp } from '../types/wardrobe-item'
import { getWardrobeItemsArgsToParams } from '../transformers/wardrobe-item'

export const getWardrobeCatalogs = () => api.get<GetWardrobeCatalogsResp>('/wardrobe/catalogs')

export const getProfileUserInfo = (userId: number) =>
  api.get<ProfileUserInfoResp>(`users/${userId}/profile`)

export const getSellerFilters = () => api.get<GetSellerFiltersResp>('/closet/seller_filters')

export const getUserItemFacets = ({ userId }: GetUserItemFacetsArgs) =>
  api.get<ItemFacetsResp>(`/users/${userId}/item_facets`)

export const getWardrobeItems = (args: GetWardrobeItemsArgs) =>
  api.get<GetWardrobeItemsResp>(`/wardrobe/${args.userId}/items`, {
    params: getWardrobeItemsArgsToParams(args),
    headers: moneyObjectHeader,
  })
